import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  deleteWebinarService,
  getWebinarService,
} from "../../../utils/services/webinar/webinarService";
import { toast } from "react-toastify";

const initialState = {
  webinarLoading: true,
  webinarError: "",
  webinarInfo: [],
  webinarStatInfo: [],
  total: 0,
  currentPage: 99999,
  currentPageLimit: 0,
  searchKey: "",
  searchKeyAdvanced: "",
  category: "",
  speaker: "",
  date: "",
  recordingAvailable: null,
  publishedWebinarIds: [], // IDs of webinars fetched with web=true
};
// Get Published Webinars (web=true)
export const getPublishedWebinars = createAsyncThunk(
  "/webinar/getPublished",
  async () => {
    // Always call the published webinars API with fixed params
    const response = await getWebinarService({
      currentPageLimit: 0,
      currentPage: 99999,
      web: true,
      searchKey: "",
      searchKeyAdvanced: "",
      category: "",
      speaker: "",
      date: "",
      recordingAvailable: null,
    });
    return response;
  }
);

// Get Webinar
export const getWebinar = createAsyncThunk(
  "/webinar/get",
  async (_, thunkAPI) => {
    console.log("Hellooo");

    const {
      currentPage,
      currentPageLimit,
      searchKey,
      searchKeyAdvanced,
      category,
      speaker,
      date,
      recordingAvailable,
    } = thunkAPI.getState().webinarList;

    console.log("Hehehe", currentPage);

    // console.log("Hellooo");

    const payload = {
      currentPage,
      currentPageLimit,
      searchKey,
      searchKeyAdvanced,
      category,
      speaker,
      date,
      recordingAvailable,
    };

    console.log("ohoo");
    const response = await getWebinarService(payload);
    // if (response?.error) {
    //   return thunkAPI.rejectWithValue(response?.error);
    // }
    console.log(response, "ahem");
    return response;
  }
);

export const deleteWebinar = createAsyncThunk(
  "/webinar/delete",
  async (payload, thunkAPI) => {
    const response = await deleteWebinarService(payload);
    if (
      response?.data?.statusCode === 200 ||
      response?.data?.statusCode === 201
    ) {
      toast.success(response?.data?.message)
      thunkAPI.dispatch(getWebinar());
    }
    return response;
  }
);

const webinarSlice = createSlice({
  name: "subAdmin",
  initialState,
  reducers: {
    pageChanged(state, action) {
      state.currentPage = action.payload;
    },
    searchKeyChanged(state, action) {
      state.searchKey = action.payload;
    },
    searchKeyAdvancedChanged(state, action) {
      state.searchKeyAdvanced = action.payload;
    },
    categoryChanged(state, action) {
      state.category = action.payload;
    },
    speakerChanged(state, action) {
      state.speaker = action.payload;
    },
    dateChanged(state, action) {
      state.date = action.payload;
    },
    recordingAvailableChanged(state, action) {
      state.recordingAvailable = action.payload;
    },
    pageLeft(state) {
      state.searchKey = "";
    },
    pageLimit(state, action) {
      console.log(action, "onnn");
      state.currentPageLimit = action.payload;
    },
    setPublishedWebinarIds(state, action) {
      state.publishedWebinarIds = action.payload;
    },
  },
  extraReducers: (builder) => {
    // GET SubAdmin User
    builder.addCase(getWebinar.pending, (state) => {});
    builder.addCase(getWebinar.fulfilled, (state, action) => {
      console.log("Tameez", state, action);
      // Remove non-serializable headers from payload if present
      const { data } = action?.payload || {};
      if (data && data.payload) {
        state.webinarInfo = data.payload;
      } else {
        state.webinarInfo = [];
      }
    });
    builder.addCase(getWebinar.rejected, (state, action) => {});

    // GET Published Webinars (web=true)
    builder.addCase(getPublishedWebinars.fulfilled, (state, action) => {
      // Debug: log the raw response
      const { data } = action?.payload || {};
      let webinars = data?.payload?.onDemand;
      if (!Array.isArray(webinars)) {
        webinars = [];
      }
      state.publishedWebinarIds = webinars.map(w => w.id);
    });
  },
});

export const {
  pageChanged,
  sortingChanged,
  searchKeyChanged,
  pageLeft,
  pageLimit,
  categoryChanged,
  speakerChanged,
  dateChanged,
  searchKeyAdvancedChanged,
  recordingAvailableChanged,
  setPublishedWebinarIds,
} = webinarSlice.actions;
export default webinarSlice.reducer;
